import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const ProductWidgetSwipeLayoutStyle = styled.div`
  .widget-top-image {
    width: 100%;
    margin-bottom: 20px;
  }

  .widget-product-section {
    display: flex;
    overflow: auto;
    width: 100%;
    padding: 0 16px;

    .widget-product-item {
      flex: 0 0 auto;

      &:not(:last-child) {
        margin-right: 15px;
      }
    }

    &.big {
      .widget-product-item {
        width: 56%;
      }
    }

    &.small {
      .widget-product-item {
        width: 37%;
      }
    }
  }
`;
